import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router'
import {
  AppBar,
  Badge,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
  TextField,
  makeStyles
} from '@material-ui/core'
import {
  AccountCircle,
  Mail,
} from '@material-ui/icons'
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';
import MenuIcon from '@material-ui/icons/Menu'
import { STATUS } from '../../helpers/constants'
import { signout } from '../../reducers/auth/session'
import logo from '../../img/Brihha.png'
import InfoIcon from '@material-ui/icons/Info';
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
const messages = {
  header: '',
  signin: 'SignIn',
  signout: 'Sign out',
  profile: 'My Profile',
  getHelp: 'Get help',
}

const drawerWidth = 280

const useStyles = makeStyles(theme => ({
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    color: 'black'
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  title: {
    flex: 1,
    marginLeft: '10px',
  },
  link: {
    textDecoration: 'none',
    color: 'black',
  },
  img: {
    height: '55px',
  },
  header: {
    fontSize: '12px',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)'
  },
  TextField:{
    width: '41%',
    marginRight:'24%'
  },
  notchedOutline: {
    borderRadius:"42px",
    backgroundColor:'#fafafa',
    zIndex:'-111'
  }
}))

const CustomAppBar = (props) => {
  const { auth, is_approved, open, handleDrawerOpen, signout } = props
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)
  const openMenu = Boolean(anchorEl)

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  let history = useHistory()
  let location = useLocation()

  return (
    <AppBar
      position="fixed"
      className={clsx(classes.appBar, {
      })}
    >
      <Toolbar>
        {(auth && is_approved === STATUS.approved) ?
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, open && classes.hide)}
          >
            <MenuIcon />
          </IconButton>
          :
          null}
        <Typography variant="h6" noWrap className={classes.title}>
          {(auth && is_approved === STATUS.approved) ?
            <Link to='/dashboard' className={classes.link}>
              <img src={logo} alt="Logo" className={classes.img} />
              <span className={classes.header} style={{ left: '235px' }} >{messages.header}</span>
            </Link>
            :
            <Link to='/' className={classes.link}>
              <img src={logo} alt="Logo" className={classes.img} />
              <span className={classes.header} style={{ left: '200px' }} >{messages.header}</span>
            </Link>}
        </Typography>
        <TextField
          className={classes.TextField}
          label="Search Here"
          variant="outlined"
          size="small"
          InputProps={{
            classes: {
              notchedOutline: classes.notchedOutline
            },
            endAdornment: (
              <InputAdornment>
                <IconButton>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            )
          }}
        />
        
        {(auth) ?
          <div>
            <IconButton color="inherit" onClick={() => { history.push('/messages') }}>
              <Badge badgeContent={0} color="primary">
                <InfoIcon />
              </Badge>
              <Typography style={{ fontSize: '13px' }} variant="h6" noWrap >{messages.getHelp}</Typography>
            </IconButton>
            <IconButton color="inherit" onClick={() => { history.push('/messages') }}>
              <Badge badgeContent={0} color="primary">
                <Mail />
              </Badge>

            </IconButton>
            <IconButton color="inherit" onClick={() => { history.push('/messages') }}>
              <Badge badgeContent={0} color="primary">
                <NotificationsNoneIcon />
              </Badge>
            </IconButton>

            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              getContentAnchorEl={null}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              open={openMenu}
              onClose={handleClose}
            >
              <MenuItem selected={location.pathname == '/myprofile' ? true : false} onClick={() => { history.push('/myprofile'); setAnchorEl(null); }}>{messages.profile}</MenuItem>
              <MenuItem onClick={signout}>{messages.signout}</MenuItem>
            </Menu>
          </div>
          : null}
      </Toolbar>
    </AppBar>
  )
}

const mapDispatchToProps = dispatch => ({
  signout: () => dispatch(signout()),
})

const mapStateToProps = state => ({
  auth: state.session.authorized,
  is_approved: state.session.is_approved,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CustomAppBar)